import React, { ChangeEvent, ReactElement, useEffect, useState } from "react";
import style from "../../../components/pageHeader/pageHeader.module.css";
import bodystyle from "./createCertificateCondition.module.css";
import Editor from "../../../components/Editor/Editor";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../constants/Constants";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { useUser } from "../../../contexts/UserContext";
import { _axios } from "../../../utils/axios";

const CreateCertificateConditions = () => {

    const { state } = useLocation();
    const documentData = state?.documentData;
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(100);
    const [certificateConditionList, setCertificateConditionList] = useState<any>([]);
    const [serviceType, setServiceType] = useState([])

    const [formData, setFormData] = useState({
        condition: documentData?.condition ?? "",
        status: documentData?.status === 1 ?? false,
        name_of_service: documentData?.name_of_service ?? "0",
        submitted_date: documentData?.submitted_date ?? '',
    });


    const handleInputChange = (e: { target: { name: string; value: string | boolean | Date; }; }) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        // Handle form submission logic here, such as sending data to a server.
    };

    const getServiceType = () => {
        _axios.get(`${BASE_URL}/api/certificate-condition/types`)
            .then(function (response) {
                console.log('response', response);
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                setServiceType(response?.data?.data)
            })
            .catch(function (error) {
                // handle error
                if (error?.response?.data?.message) {
                    ErrorToast(error?.response?.data?.message)
                }
                console.log('error', error);
            })

    }

    // Get list of records
    const getCertificateConditionList = () => {
        _axios.post(`${BASE_URL}/api/certificate-condition/list`,
            {
                page: currentPage,
                limit: entriesPerPage
            }
        )
            .then(function (response) {
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                setCertificateConditionList(response?.data?.data?.results)

                // handle success
                console.log(response);
            })
            .catch(function (error: any) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    useEffect(() => {
        getCertificateConditionList()
        getServiceType()
    }, [])



    const onSubmit = () => {

        if (formData.condition.length === 0) {
            ErrorToast("Please enter Conditions for Certificate")
            return
        }
        if (formData.name_of_service.length === 0) {
            ErrorToast("Please select valid Name of Service")
            return
        }

        const data = {
            name_of_service: formData.name_of_service,
            condition: formData.condition,
            status: formData.status ? 1 : 0,
            submitted_date: formData.submitted_date,
        }

        if (documentData !== undefined) {
            _axios.patch(`${BASE_URL}/api/certificate-condition`, { ...data, id: documentData?.id })
                .then(function (response) {
                    console.log('response', response);
                    if (response?.data?.success === 0) {
                        ErrorToast(response?.data?.message)
                        return
                    }
                    SuccessToast('Certificate Condition Updated')
                    navigate('/certificate-condition');

                    // handle success

                })
                .catch(function (error) {
                    // handle error
                    if (error?.response?.data?.message) {
                        ErrorToast(error?.response?.data?.message)
                    }
                    console.log('error', error);
                })
        }
        else {

            _axios.post(`${BASE_URL}/api/certificate-condition/checkexistingrecord`, {
                params: {
                    name_of_service: formData.name_of_service,
                    status: formData.status ? 1 : 0
                }
            }).then(function (response) {
                console.log('Check Existing Record Response:', response);
                const similarRecords = response.data;
                if (similarRecords.length > 0) {
                    // If a similar record exists, display an error message or handle it accordingly
                    ErrorToast("A similar record already exists with active status");
                } else {
                    // If no similar record exists, execute the create _axios to proceed with creating/updating the record
                    _axios.post(`${BASE_URL}/api/certificate-condition/create`, data)
                        .then(function (response) {
                            console.log('response', response);
                            if (response?.data?.success === 0) {
                                ErrorToast(response?.data?.message)
                                return
                            }
                            SuccessToast('Certificate Condition Added')
                            navigate('/certificate-condition');
                            // handle success
                        })
                        .catch(function (error) {
                            // handle error
                            if (error?.response?.data?.message) {
                                ErrorToast(error?.response?.data?.message)
                            }
                            console.log('error', error);
                        })
                }
            })
                .catch(function (error) {
                    // handle error
                    if (error?.response?.data?.message) {
                        ErrorToast(error?.response?.data?.message)
                    }
                    console.log('error', error);
                })
        }

    }


    return (
        <div className="p-8" >
            {/* Header */}
            <div className={style.divBodyHeading}>
                <div className={style.headerContent}>
                    <p className={style.bodyTitle}>{documentData ? 'Edit' : 'Create'} Certificate Conditions</p>
                </div>

                <div className={style.rightContent}>
                    <button className={style.newUserButton} onClick={onSubmit}>
                        Publish
                    </button>

                    <button className={style.newUserButton} onClick={onSubmit}>
                        Save
                    </button>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                {/* Content Card */}
                <BoxComponent>
                    <div className={bodystyle.card}>
                        <div className={bodystyle.rowHeader}>
                            <div className={bodystyle.rowOne}>
                                <label className={bodystyle.title}>Name of Service</label>
                                <select
                                    id="serviceType"
                                    name="name_of_service"
                                    className={bodystyle.selectwhite}
                                    value={formData.name_of_service}
                                    disabled={documentData !== undefined}
                                    style={{ backgroundColor: documentData !== undefined ? '#c5c5c5' : 'white' }}
                                    onChange={handleInputChange}
                                >
                                    <option value={'0'} selected disabled>Select Service</option>
                                    {serviceType?.map((type: any) => {
                                        // Check if the service is already present in the results array
                                        const isDisabled = certificateConditionList?.length > 0 ? certificateConditionList?.some((result: any) => result?.name_of_service === type?.name) : false;
                                        return (
                                            <option value={type?.name} disabled={isDisabled}>{type?.name}</option>
                                        );
                                    })}
                                </select>
                            </div>

                            <div className={bodystyle.rowTwo}>
                                <label className={bodystyle.footerActive}>Activate</label>
                                <div className={bodystyle.footerAct}>
                                    <label className={bodystyle.toggleBtn}>
                                        <input
                                            type="checkbox"
                                            checked={formData.status}
                                            onClick={() => handleInputChange({ target: { name: 'status', value: !formData.status } })}
                                            className={bodystyle.inputCheckbox}
                                        />
                                        <span className={bodystyle.slider}></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className={bodystyle.smallLable}>Condition for Certificate</div>
                        <textarea
                            id="name"
                            name="condition"
                            className={bodystyle.footerTextarea}
                            placeholder="Enter Conditions for Certificate"
                            value={formData.condition}
                            onChange={handleInputChange}
                        />
                        <div className={bodystyle.buttonSection} style={{ paddingTop: "2%", paddingBottom: '2%' }}>
                            <button
                                // className={bodystyle.closeButton}
                                className="closeButtonCss"
                                onClick={() => navigate('/certificate-condition')}>
                                Close
                            </button>
                        </div>
                    </div>
                </BoxComponent>
            </form>
        </div>
    );
};

export default CreateCertificateConditions
